;
define("item_relations_cell.tpl", function(){});

